var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "h5-tabbar" }, [
    _c(
      "div",
      {
        staticClass: "h5-tabbar-item",
        class: { active: _vm.active === "orders" },
        on: {
          click: function ($event) {
            return _vm.go("/h5/orders")
          },
        },
      },
      [
        _c("a-icon", { attrs: { type: "profile" } }),
        _c("span", [_vm._v("订单")]),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "h5-tabbar-item",
        class: { active: _vm.active === "partners" },
        on: {
          click: function ($event) {
            return _vm.go("/h5/partners")
          },
        },
      },
      [_c("a-icon", { attrs: { type: "team" } }), _c("span", [_vm._v("伙伴")])],
      1
    ),
    _c(
      "div",
      {
        staticClass: "h5-tabbar-item",
        class: { active: _vm.active === "scan" },
        on: {
          click: function ($event) {
            return _vm.go("/h5/scan")
          },
        },
      },
      [
        _c("a-icon", { attrs: { type: "scan" } }),
        _c("span", [_vm._v("扫码入库")]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }